import React, { useContext, useState } from 'react';
import { WalletContext } from '../context/WalletContext';

const ConnectWallet = () => {
  const { account, setAccount } = useContext(WalletContext);
  const [error, setError] = useState(null);

  const metaBenzChainId = '0x17de6'; // Replace with MetaBenz chain ID (in hex format)
  const metaBenzNetworkParams = {
    chainId: metaBenzChainId, // Chain ID (in hex)
    chainName: 'MetaBenz CHAIN', // Replace with actual chain name
    nativeCurrency: {
      name: 'MetaBenz Coin', // Currency name
      symbol: 'MBC', // Currency symbol
      decimals: 18, // Decimals
    },
    rpcUrls: ['http://rpc.metabenzscan.com'], // RPC URL
    blockExplorerUrls: ['https://metabenzscan.com/'], // Block Explorer URL
  };

  // Function to switch to MetaBenz chain
  const switchNetwork = async () => {
    if (window.ethereum) {
      try {
        // Try to switch the network
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: metaBenzChainId }],
        });
      } catch (error) {
        // If the chain is not added, try to add it
        if (error.code === 4902) {
          try {
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [metaBenzNetworkParams],
            });
          } catch (addError) {
            setError('Failed to add MetaBenz network');
            console.error(addError);
          }
        } else {
          setError('Failed to switch network');
          console.error(error);
        }
      }
    }
  };

  // Function to connect the wallet and switch to MetaBenz chain
  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        // First, switch the network
        await switchNetwork();

        // Then, request the user's accounts
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        setAccount(accounts[0]);
        setError(null); // Clear any previous errors
      } catch (error) {
        if (error.code === 4001) {
          setError('User denied account access');
        } else {
          setError('Error connecting to MetaBenz network');
        }
        console.error(error);
      }
    } else {
      setError('MetaMask not found. Please install MetaMask!');
    }
  };

  // Function to disconnect the wallet
  const disconnectWallet = () => {
    setAccount(null); // Reset account state to null or empty string to disconnect
  };

  return (
    <>
      {/* Wallet Section Start */}
      <section className="hero-wrap style1">
        <div className="container fluid">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-5 col-sm-8">
              <div className="gradient-card">
                <div className="card p-4 rounded-5 footer-wrap border-golden pt-5 pb-5">
                  <div className="logo-bhts" align="center">
                    <img
                      src="assets/img/resources/logo-white.png"
                      alt=""
                      className="img-responsive"
                      width={300}
                    />
                  </div>
                  <div className="header-btn pt-5 pb-2" align="center">
                    
                    {/* Render the Connect Wallet button only if no account is connected */}
                    {!account && (
                      <button className="btn style1" onClick={connectWallet}>
                        Connect Wallet
                        <i className="fas fa-wallet" />
                      </button>
                    )}
                    
                    {/* Display Account Address */}
                    {account && <p style={{ color: 'white' }}> {account}</p>}
                    
                    {/* Disconnect Wallet Button */}
                    {account && (
                      <button className="btn style1" onClick={disconnectWallet}>
                        Disconnect
                        <i className="fas fa-wallet" />
                      </button>
                    )}
                  </div>

                  {/* Sample Text */}
                  <p id="hiddenText" className="text-center">
                    please connect or install with metamask
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Wallet Section End */}
    </>
  );
};

export default ConnectWallet;
